import React from "react";
import { Section, FadeUp, SectionHeading } from "./primitives";
import { testimonials } from "@/data/content";

export const Testimonials = () => (
  <Section className="bg-zinc-50">
    <div className="max-w-[1100px] mx-auto">
      <FadeUp className="text-center max-w-[720px] mx-auto">
        <SectionHeading>What Past Students Say About Doug</SectionHeading>
      </FadeUp>
      <div className="mt-12 grid gap-6 md:grid-cols-2">
        {testimonials.map((t, i) => (
          <FadeUp key={t.name} delay={i * 0.05}>
            <figure
              data-testid={`testimonial-card-${i}`}
              className="h-full bg-white border border-zinc-200 rounded-xl p-8 md:p-10 shadow-sm hover:shadow-md transition-shadow duration-300 flex flex-col"
            >
              <blockquote className="text-lg text-zinc-700 leading-relaxed flex-1">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-4">
                <img
                  src={t.avatar}
                  alt={`${t.name}, electric guitarist and student`}
                  loading="lazy"
                  className="h-[76px] w-[76px] md:h-24 md:w-24 rounded-full object-cover border border-zinc-200"
                />
                <span className="font-bold text-zinc-900">{t.name}</span>
              </figcaption>
            </figure>
          </FadeUp>
        ))}
      </div>
    </div>
  </Section>
);
